import { FunctionComponent } from "react";
import { ApplyIssue, ApplyPreviewResult } from "../models/types";

const IssueList: FunctionComponent<{
  title: string;
  issues: ApplyIssue[];
  tone: "red" | "amber";
}> = ({ title, issues, tone }) => {
  const toneCls =
    tone === "red"
      ? "border-red-200 bg-red-50 text-red-700"
      : "border-amber-200 bg-amber-50 text-amber-700";
  return (
    <div className={`border rounded-md p-3 text-xs space-y-1 ${toneCls}`}>
      <p className="font-semibold">{title}</p>
      <ul className="list-disc pl-4 space-y-1">
        {issues.map((iss, i) => (
          <li key={i}>{iss.message}</li>
        ))}
      </ul>
    </div>
  );
};

// Mirrors StockActionPreviewPanel's shape (bulk_stock_upload/StockActionPreviewPanel.tsx)
// for the Request Desk apply-preview/apply flow — same visual language, different
// payload (planned_actions instead of rows/wac_impact).
const ApplyPreviewPanel: FunctionComponent<{ preview: ApplyPreviewResult }> = ({
  preview,
}) => (
  <div className="border rounded-md p-3 space-y-2 bg-gray-50">
    <div className="flex items-center gap-2 flex-wrap">
      <span
        className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
          preview.ok ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
        }`}
      >
        {preview.ok ? "Ready to apply" : "Blocked"}
      </span>
      <p className="text-sm text-gray-700">{preview.summary}</p>
    </div>

    {preview.blocking_errors.length > 0 && (
      <IssueList
        title="This change can't be made automatically"
        issues={preview.blocking_errors}
        tone="red"
      />
    )}
    {preview.warnings.length > 0 && (
      <IssueList title="Please note" issues={preview.warnings} tone="amber" />
    )}

    {preview.planned_actions.length > 0 && (
      <div className="border rounded-md bg-white p-3 text-xs space-y-1">
        <p className="font-semibold text-gray-700">What this will do</p>
        <ul className="list-disc pl-4 space-y-1 text-gray-600">
          {preview.planned_actions.map((a, i) => (
            <li key={i}>{a.summary}</li>
          ))}
        </ul>
      </div>
    )}
  </div>
);

export default ApplyPreviewPanel;
